import { render, staticRenderFns } from "./lands.vue?vue&type=template&id=7d32f9ae&"
import script from "./lands.vue?vue&type=script&lang=js&"
export * from "./lands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports